module.exports = __webpack_public_path__ + "static/media/connectwise_control_black_logo.9e80f2c8.png";